import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { setPatient, setPatientFromAxios, cleanPatient } from '../redux/reducers/patient';
import Axios from '../utils/axios';

function Search() {
	const [data, setData] = useState();
	const patient = useSelector((state) => state.patient);
	const dispatch = useDispatch();
	let updatePatient = (key, value) => dispatch(setPatient({ [key]: value }));

	useEffect(() => {
		async function searchPatient() {
			let path = 'patient/?';
			const { firstName, lastName, tel } = patient;
			path += tel && `&tel=${tel}`;
			path += lastName && `&lastName=${lastName}`;
			path += firstName && `&firstName=${firstName}`;

			const res = await Axios.get(path);
			res && setData(res.data);
		}
		searchPatient();
	}, [patient]);
	return (
		<div
			className="grid grid-rows-5 gap-10 mx-auto rounded-lg shadow md:w-11/12 bg-blue-320"
			id="Search"
		>
			<div
				key="form"
				className="grid justify-between w-11/12 h-6 max-w-full grid-cols-2 gap-4 px-4 mx-auto my-5 mb-24 md:mb-3 sm:grid-cols-4 md:grid-cols-5 "
			>
				<TextField
					label="نام"
					state={patient.firstName}
					setState={(value) => updatePatient('firstName', value)}
				/>
				<TextField
					label="نام خانوادگی"
					state={patient.lastName}
					setState={(value) => updatePatient('lastName', value)}
				/>
				<TextField
					label="شماره تماس"
					state={patient.tel}
					setState={(value) => updatePatient('tel', value)}
				/>
				<button
					className="h-8 px-3 mx-1 my-3 text-sm text-white bg-blue-600 rounded shadow hover:bg-blue-200 hover:text-gray-800 md:my-0"
					onClick={() => dispatch(cleanPatient())}
				>
					پاک کردن
				</button>
				<Link
					to="/patient/create"
					className="h-8 pt-1 pr-4 my-3 text-sm text-center text-white rounded shadow bg-cyan-600 hover:bg-blue-200 hover:text-gray-800 md:my-0"
				>
					ایجاد پرونده
				</Link>
			</div>
			<div className="row-span-4">
				<PatientList data={data} />
			</div>
		</div>
	);
}
export default Search;

function TextField(props) {
	const { state, setState, label } = props;
	return (
		<input
			key={label}
			className="h-8 pr-4 mx-3 my-3 placeholder-gray-500 rounded shadow placeholder-opacity-900 md:my-0"
			type="text"
			placeholder={label}
			value={state}
			onChange={(e) => setState(e.target.value)}
		/>
	);
}

function PatientList(props) {
	const { data } = props;
	const dispatch = useDispatch();
	return (
		<div className="mx-auto mt-10 md:mt-2">
			{data ? (
				data.map((patient, index) => (
					<Link
						key={index}
						to={`/patient/${patient.id.$oid}`}
						onClick={() => dispatch(setPatientFromAxios(patient))}
					>
						<div
							className="grid grid-cols-1 mx-6 my-3 text-white rounded shadow-lg bg-cyan-600 sm:grid-cols-3 hover:bg-cyan-500 hover:text-gray-900"
							key={`${patient.id.$oid}`}
						>
							<div className="flex my-auto sm:mx-auto sm:py-3 ">
								<span>نام: &nbsp; </span>
								{patient.first_name}
							</div>
							<div className="flex my-auto sm:mx-auto">
								<span>نام خانوادگی: &nbsp; </span> {patient.last_name}
							</div>
							<div className="flex my-auto sm:mx-auto">
								<span>شماره تلفن: &nbsp; </span> {patient.tel}
							</div>
						</div>
					</Link>
				))
			) : (
				<div
					className="flex justify-between h-10 p-1 px-4 my-3 text-white rounded shadow-lg bg-cyan-600 hover:bg-blue-200 hover:text-gray-900"
					key="non-list"
				>
					بیمار مورد نظر پیدا نشد. در صورت نیاز یک پرونده جدید ایجاد کنید.
				</div>
			)}
		</div>
	);
}
